module.exports = __webpack_public_path__ + "img/collaborate_4.2d50180a.jpg";